import { render, staticRenderFns } from "./slide2025.vue?vue&type=template&id=a6d52964"
import script from "./slide2025.vue?vue&type=script&lang=js"
export * from "./slide2025.vue?vue&type=script&lang=js"
import style0 from "./slide2025.vue?vue&type=style&index=0&id=a6d52964&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports